import { Add, BlockOutlined, ChevronRight } from '@mui/icons-material';
import {
    Button,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import ListPageLayout from '../../../components/ListPageLayout';
import { useFetch } from '../../../hooks/useFecth';
import DialogSetting from './components/DialogSetting';

export default function Settings() {
    const { data, mutate, isFetching } = useFetch('settings/items');
    const list = Array.isArray(data) ? data : data?.data ?? [];

    return (
        <>
            <ListPageLayout
                title="Configurações"
                subtitle="Parâmetros gerais da plataforma."
                counts={[{ label: 'itens', value: list.length, color: 'primary' }]}
                loading={isFetching && !data}
                showViewToggle={false}
                actions={
                    <Button size="small" variant="contained" startIcon={<Add />} component={Link} to="#setting">
                        Adicionar configuração
                    </Button>
                }
                isEmpty={!isFetching && !list.length}
                empty={
                    <Stack direction="row" justifyContent="center" alignItems="center" gap={1}>
                        <Typography color="text.secondary">Nenhum dado encontrado.</Typography>
                        <BlockOutlined />
                    </Stack>
                }
            >
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Chave</TableCell>
                                <TableCell>Valor</TableCell>
                                <TableCell>Clube</TableCell>
                                <TableCell align="right" width={80} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map(item => (
                                <TableRow key={item.id} hover>
                                    <TableCell>{item.id}</TableCell>
                                    <TableCell>{item.key ?? '—'}</TableCell>
                                    <TableCell>{item.value ?? '—'}</TableCell>
                                    <TableCell>{item?.Club?.name ?? '—'}</TableCell>
                                    <TableCell align="right">
                                        <IconButton
                                            component={Link}
                                            to={`#setting|${item.id}`}
                                            title="Abrir"
                                            size="small"
                                        >
                                            <ChevronRight />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </ListPageLayout>
            <DialogSetting mutate={mutate} />
        </>
    );
}
